// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2GS5Q","empty":"ModalGraph_empty__2h3PE"};